import React from 'react';
import loadable from '@loadable/component';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import logoNewImage from '../../assets/images/logo_new.png';
import css from './HowItWorksPage.module.css';
import { FaShoppingCart } from 'react-icons/fa';
import coopImage from '../../assets/images/sellfresh.png';
import basketImage from '../../assets/images/discover.png';
import paymentImage from '../../assets/images/card3.jpg';
import { NamedLink, Page} from '../../components';

import FallbackPage, { fallbackSections } from './FallbackPage';
import { ASSET_NAME } from './HowItWorksPage.duck';
import { camelize } from '../../util/string';
import { getMetadata } from '../PageBuilder/PageBuilder';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import howItFooter from '../../assets/images/howItFooter.png';


const steps = [
  {
    title: 'Sell Your Fresh Picks',
    description: 'List your homegrown or handmade foods and connect with local buyers looking for fresh, seasonal products.',
    buttonText: 'Start Selling →',
    buttonColor: 'green',
    image: coopImage,
    reverse: true,
  },
  {
    title: 'Discover Fresh Picks Near You',
    description: 'Browse local sellers offering fresh produce, baked goods, eggs, honey, herbs, and more.',
    buttonText: 'Browse Fresh Picks →',
    buttonColor: 'mint',
    image: basketImage,
    reverse: false,
  },
  {
    title: 'Secure Local Marketplace',
    description: 'Order confidently through Farmiez with simple checkout and direct connections to trusted local sellers.',
    buttonText: 'Browse Fresh Picks →',
    buttonColor: 'green',
    image: paymentImage,
    reverse: true,
  },
];

export const HowItWorksPageComponent = props => {
  const { pageAssetsData, currentUser } = props;
  const { meta = {} } = pageAssetsData?.[camelize(ASSET_NAME)]?.data || {};
  const pageMetaProps = getMetadata(meta, 'Article');

  return (
    <Page {...pageMetaProps} scrollingDisabled={props.scrollingDisabled}>
      <div 
        className={css.HowItWorksPage}
        // style={{
        //   backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
        // }}
      >

        <TopbarContainer />

        {/* Hero Section */}
        <div
          className={css.heroSection}
          style={{
            backgroundImage: `url(${require('../../assets/images/howitwork-hero.png')})`,
          }}
        >
          <div className={css.heroContainer}>
            <h1 className={css.heroTitle}>How Farmiez Marketplace Works</h1>
            <p className={css.titleBelowText}>Farmiez connects local growers and neighbors through a simple, trusted marketplace. Discover fresh food near you or share what you grow with your community.</p>
            <p className={css.contentText}>List what you grow or produce and connect with local buyers looking for fresh, seasonal food.</p>
          </div>
        </div>

        <div className={css.containerWarp}>
          <div className={css.contentSection}>
            <div className={css.textBlock}>
              {steps.map((step, idx) => (
                <div
                  key={idx}
                  className={`${css.row} ${step.reverse ? css.reverse : ''} ${idx % 2 === 1 ? css.altBg : ''}`}
                >
                  <div className={css.rowBox}>
                    <div className={css.textContent}>
                      <h3 className={css.title}>{step.title}</h3>
                      <p className={css.description}>{step.description}</p>
                      {idx === 0 && (
                        <>
                          {!!currentUser?.id ? (
                            <NamedLink name="NewListingPage" className={css.customBtn}>
                              {/*<span className={css.coop}>🐓</span>*/}
                              <span>{step.buttonText}</span>
                            </NamedLink>
                          ) : (
                            <NamedLink name="SignupPage" className={css.customBtn}>
                              {/*<span className={css.coop}>🐓</span>*/}
                              <span>{step.buttonText}</span>
                            </NamedLink>
                          )}
                        </>
                      )}
                      {idx === 1 && (
                        <NamedLink name="SearchPage" className={css.customBtn}>
                          {/*<span>🥚</span>*/}
                          <span>{step.buttonText}</span>
                          {/*<span className={css.coop}><FaShoppingCart className={css.cartIcon} /></span>*/}
                        </NamedLink>
                      )}
                      {idx === 2 && (
                        <NamedLink name="SearchPage" className={css.customBtn}>
                          <span>{step.buttonText}</span>
                        </NamedLink>
                      )}
                    </div>
                    <div className={css.imageWrapper}>
                      <img src={step.image} alt={step.title} className={css.image} />
                    </div>
                  </div>
                </div>
              ))}

              <NamedLink name="FarmiezFieldGuidesPage" className={css.readguidesLink}>
                Read the Farmiez Field Guides →
              </NamedLink>
              
            </div>
          </div>

          {/*<img src={howItFooter} alt="img" className={css.footerImg} />*/}
        </div>
        
        <FooterContainer />
      </div>
    </Page>
  );
};

HowItWorksPageComponent.propTypes = {
  // pageAssetsData: object,
  // inProgress: bool,
  // error: propTypes.error,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { pageAssetsData } = state.hostedAssets || {};

  return {
    pageAssetsData,
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const HowItWorksPage = compose(connect(mapStateToProps))(HowItWorksPageComponent);

export default HowItWorksPage;
